import * as qs from 'qs';

import { getToken } from 'common/api/axios.config';

export function toApiError(err: any): string {
  if (err.response && err.response.data && err.response.data.error_description) {
    return err.response.data.error_description;
  } else if (err.response && err.response.data && err.response.data.message) {
    return err.response.data.message;
  } else {
    let status = err.response && err.response.status ? err.response.status : -1;
    return (
      'We are having difficulty connecting to the server.' +
      ' Please check your internet connection and try again. (code ' +
      status +
      ')'
    );
  }
}

export function getExportUrl(path: string, params?: object) {
  const accessToken = getToken();
  return process.env.REACT_APP_API_URL + path + '?' + qs.stringify({ ...params, access_token: accessToken });
}

export function getChaptersWordPressUrl(path: string) {
  return process.env.REACT_APP_LEGACY_WP_URL + path;
}



// WEBPACK FOOTER //
// ./src/common/utils/api.ts